import React, {useContext} from "react";
import {Link as RouterLink} from "react-router-dom";
import {AirlineStops, ArrowBack, East, ArrowForward} from "@mui/icons-material";
import {Box, Button, Card, CircularProgress, Fab, Typography} from "@material-ui/core";
import { RestartAlt } from "@material-ui/icons";
import Popover from "@mui/material/Popover/Popover";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";


import {BookingsFlowContext} from "../../../contexts/BookingsFlowContext";
import { BrandContext } from "../../../contexts/BrandContext";




export const ManyLegsIcon = () => (
    <AirlineStops />
);

export const DirectTravelIcon = () => (
    <East/>
);

export const BigTitle = (props) => (
    <div className="slideTitle">
        <Typography align="center" variant="h1" sx={{textTransform: 'capitalize'}}>
            {props.children}
        </Typography>
    </div>
)

export const FooterButtons = (props) => (
    <Box display="flex"  alignItems="flex-start" className="lowButtonContainer">
        {props.children}
    </Box>
)



export const InfoPop = (props) => {

    const [anchorEl, setAnchorEl] = React.useState(null);
    const brandContext = useContext(BrandContext);
    const {
        brand:{
            schoolConfig:{
                showInfoPops=true
            }
        }
    } = brandContext;
    

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };



    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    if(!showInfoPops){
        return null;
    }

    if(props.children) {

        return (<>
            <Fab 
                sx={{position:'absolute', top:20, right:20}} 
                size="small" 
                aria-describedby={id} 
                color="primary" 
                onClick={handleClick}
            >
                <InfoOutlinedIcon />
            </Fab>

            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <Box sx={{width: 400, padding: 2}}>
                    {props.children}
                </Box>
            </Popover>
        </>);
    }
    return <></>;

};

export const InfoPersistent = (props) => {
    if(props.children){
        return (<Typography className="topHelperText">{props.children}</Typography>);
    }
    return <></>;
};

export const CardContainer = (props) => (
    <Box mb={3}>
        <Card sx={{ p: 3 }}  mb={3}>
            {props.children}
        </Card>
    </Box>
);


export const BackButton = (props) => {
    const bookingsContext = useContext(BookingsFlowContext);

    const {
        to='',
        buttonText:propsButtonText='',
        clickAction:propsClickAction=null
    } = props;

    const {
        textContent:{
            backButton=''
        },
        goBack:goBackFunction
    } = bookingsContext;

    const buttonText = propsButtonText !== '' ? propsButtonText : backButton;

    const clickAction = propsClickAction !== null ? propsClickAction : goBackFunction;
    
    if(to !== ''){
        return (<Button
                className='backButton'
                variant="outlined"
                component={RouterLink}
                to={to}
                startIcon={<ArrowBack/>}
            >
                {buttonText}
            </Button>
        );
    }
    return (<Button
            className='backButton'
            variant="outlined"
            onClick={clickAction}
            startIcon={<ArrowBack/>}
        >
            {buttonText}
        </Button>
    );
    
    
}

export const ResetButton = (props) => {
    const bookingsContext = useContext(BookingsFlowContext);
    return (<Button
        className='resetButton'
        variant="outlined"
        onClick={bookingsContext.restartBooking}
        startIcon={<RestartAlt/>}
    >
        {props.buttonText ? props.buttonText : bookingsContext.textContent.resetButtonText}
    </Button>
);
}

export const NextButton = (props) => {
    const bookingsContext = useContext(BookingsFlowContext);
    return (
        <Button
            variant="outlined"
            onClick={props.clickAction}
            disabled={props.disabled}
            endIcon={<ArrowForward/>}
        >
            {props.buttonText ? props.buttonText : bookingsContext.textContent.nextButton}
        </Button>
    );
}

export const LoadingBox = () =>(
    <Box sx={{ display: 'flex' }} justifyContent="center" m={2}>
        <CircularProgress color="primary" />
    </Box>
);